import { jsx as _jsx } from "react/jsx-runtime";
import circleChevronUpIcon from '@/core/svg/fa/circle-chevron-up.svg';
import { IconButton } from '@/core/ui/IconButton';
import { styled } from '@/core/ui/muiReexports';
import { SvgIcon } from '@/core/ui/SvgIcon';
export const ScrollToTopButton = () => {
    const handleClick = () => {
        window.scrollTo(0, 0);
    };
    return (_jsx(ScrollToTopButtonRoot, { children: _jsx(IconButton, { disableRipple: true, onClick: handleClick, children: _jsx(SvgIcon, { icon: circleChevronUpIcon, size: "2.3rem" }) }) }));
};
const ScrollToTopButtonRoot = styled('div')(({ theme }) => ({
    position: 'absolute',
    // `top` should not be using, since if TableHead has different width it may overlap the button. Better to use `bottom`
    // with negative value, it will be anchored properly. `marginTop` works fine also.
    // top: theme.spacing(14),
    marginTop: theme.spacing(3),
    right: theme.spacing(4),
    opacity: 0.3,
    ':hover': { opacity: 1 },
}));
